// https://vuex.vuejs.org/guide/modules.html
import getters from "./getters";
import mutations from "./mutations";

const menus = {
  namespaced: true,
  state: {
    menuData: []
  },
  getters,
  mutations
};

export default menus;
